// src/services/MilestoneService.ts

import { BaseService } from "@services/BaseService";
import { MilestonePayload } from "@shared/interfaces/ProgramFiles";

class MilestoneService extends BaseService {
  createMilestone(data: MilestonePayload) {
    return this.post("/programs/milestones", data);
  }

  getMilestoneById(milestoneId: string | number) {
    return this.get(`/programs/milestones/${milestoneId}`);
  }

  updateMilestone(
    milestoneId: string | number,
    data: Partial<MilestonePayload>
  ) {
    return this.patch(`/programs/milestones/${milestoneId}`, data);
  }

  deleteMilestone(milestoneId: string | number) {
    return this.delete(`/programs/milestones/${milestoneId}`);
  }

  getProjectMilestones(programId: number, projectId: string | number) {
    return this.get(`/programs/${programId}/project/${projectId}/milestones`);
  }

  getProgramMilestones(
    programId: string | number,
    params?: { start_date: string; end_date: string }
  ) {
    return this.get(`/programs/${programId}/milestones`, { params });
  }

  getProgramLinkedProjects(
    programId: string | number,
    params?: { offset?: number; limit?: number }
  ) {
    return this.get(`/programs/${programId}/linked-projects`, { params });
  }
}

export const milestoneService = new MilestoneService();
